// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2U26m","messages":"Chat_messages__3-UKc","dateDivider":"Chat_dateDivider__11KJg"};